import { render, staticRenderFns } from "./work-user.vue?vue&type=template&id=f5cb654c&scoped=true"
import script from "./work-user.vue?vue&type=script&lang=ts"
export * from "./work-user.vue?vue&type=script&lang=ts"
import style0 from "./work-user.vue?vue&type=style&index=0&id=f5cb654c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5cb654c",
  null
  
)

export default component.exports